import Vue from 'vue'
import App from './App.vue'
import router from './router'
import money from 'v-money'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'

Vue.use(Vuex)

Vue.use(money, {
  decimal: '.',
  thousands: ',',
  prefix: '$',
  precision: 2,
  masked: true
})
Vue.use(VueAxios, axios)

const store = new Vuex.Store({
  state: {
    stonky: false,
    labz: false,
  },
  mutations: {
    setStonky (state) {
      state.stonky = true
    },
    setLabz (state) {
      state.labz = true
    }
  }
})

import "soft-ui-library/dist/css/neumorphism-ui.css"
import './assets/main.scss'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
